import React from "react";

const PagIcon = () => {
  return (
    <>
      <svg
        width="24"
        height="24"
        viewBox="0 0 24 24"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <circle cx="12" cy="12" r="12" fill="#0F6FDF" />
        <g clipPath="url(#clip0_5_2463)">
          <path
            d="M11.3 7.7999H17.6M11.3 11.9999H17.6M12 16.1999H17.6M6.39999 14.7999C6.39999 14.4286 6.54749 14.0725 6.81004 13.81C7.0726 13.5474 7.42869 13.3999 7.79999 13.3999C8.1713 13.3999 8.52739 13.5474 8.78994 13.81C9.05249 14.0725 9.19999 14.4286 9.19999 14.7999C9.19999 15.2136 8.84999 15.4999 8.49999 15.8499L6.39999 17.5999H9.19999M7.79999 10.5999V6.3999L6.39999 7.7999"
            stroke="white"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </g>
        <defs>
          <clipPath id="clip0_5_2463">
            <rect
              width="14"
              height="14"
              fill="white"
              transform="translate(5 5)"
            />
          </clipPath>
        </defs>
      </svg>
    </>
  );
};

export default PagIcon;
